module.exports = __webpack_public_path__ + "img/miraqleslogo.58c8b376.svg";